import MdaeTextArea from "./component";
import { ITextAreaOptions } from "devextreme-react/text-area";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeTextAreaProps extends ITextAreaOptions {
  id: string;
  mdaeTextAreaTitle: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
  showRemainingCharecters?: boolean;
  madeFieldTitleClassName?:string;
}
export default MdaeTextArea;
